// @flow

import React from 'react';

import {DocumentAlertBox} from './DocumentAlertBox';
import {gt} from 'app/utils/i18n';
import {getContentType} from 'app/utils/content-type';
import {getApprovalArticleLink} from './NoApprovedVersionsAlertBox';
import type {VersionableDocumentTypes} from 'app/general/types';

type Props = {contentType: VersionableDocumentTypes};

export const ApproveToMakeItLiveAlertBox = ({contentType}: Props) => {
  const ct = getContentType(contentType).name;
  const article = getApprovalArticleLink();

  return (
    <DocumentAlertBox
      type="warning"
      icon="fa-exclamation-triangle"
      title={gt('You must approve this draft to make it live')}
      content={gt(
        'A guide about approving a %(ct)s is available in our knowledge base %(article)s',
        {ct, article}
      )}
    />
  );
};

export const showApproveToMakeItLiveAlertBoxIfNotApproved = (
  contentType: VersionableDocumentTypes,
  approved_at: string | null
) =>
  approved_at != null ? null : (
    <ApproveToMakeItLiveAlertBox contentType={contentType} />
  );
